import { Reducer } from 'redux'

import {
  BuyerMeteringsAction,
  BuyerMeteringsActionTypes,
  initialBuyerMeteringsState,
  Meterings,
} from './types'

export const reducer: Reducer<Meterings, BuyerMeteringsAction> = (
  state = initialBuyerMeteringsState,
  action
) => {
  switch (action.type) {
    case BuyerMeteringsActionTypes.SET_BUYER_METERINGS: {
      return {
        ...state,
        meterings: action.payload.meterings,
      }
    }
    default:
      return state
  }
}
